/**
 * Stable identity for a timeline row. `__id` wins so keys match what the Relay path produced; a
 * TanStack-backed timeline has no `__id` and is keyed by the server `id`.
 */
export type TimelineItemIdentity = {readonly __id: string; readonly id?: string} | {readonly id: string}

export function timelineItemKey(item: TimelineItemIdentity): string {
  return '__id' in item ? item.__id : item.id
}
